import { render, staticRenderFns } from "./MDList.vue?vue&type=template&id=0f127ec5&"
import script from "./MDList.vue?vue&type=script&lang=js&"
export * from "./MDList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports